module.exports = __webpack_public_path__ + "static/media/okGreen.d7e5b507.svg";